/** The app's mark: a rising line ending in a dot, on a lifted tile. */
export function BrandMark({ className = "size-8" }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={`shrink-0 ${className}`} aria-hidden>
      <rect x="0.75" y="0.75" width="62.5" height="62.5" rx="16" fill="var(--panel-3)" stroke="var(--border-strong)" strokeWidth="1.5" />
      <path d="M14 43 L25 32 L33 38 L50 20" fill="none" stroke="var(--up)" strokeWidth="5.5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="50" cy="20" r="5" fill="var(--accent)" />
    </svg>
  );
}
